import React from "react";
import { Alert, Icon, Button } from "antd";
import get from "lodash/get";

import { RedcapPullRequest, RedcapPushRequest, RedcapCheckStatus } from "../../api/requests";

import classes from "./PatientProfileForm.css";
import { withNamespaces } from "react-i18next";

const statuses = {
  'completed': 'success',
  'declined': 'error',
  'error': 'error',
  'pending': 'warning',
  'idle': 'info',
};

class PatientRedcapProcessing extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isSent: false,
      isLoading: false,
      requestResult: null,
      isSentStatus: false,
      isLoadingStatus: false,
      requestResultStatus: null,
      isSentPullStatus: false,
      requestResultPullStatus: null,
    };
  }

  handlePullSubmit = async () => {
    this.setState({ isLoading: true });
    try {
      const data = await RedcapPullRequest(this.props.subjectID);

      this.setState({
        isSentPullStatus: true,
        requestResultPullStatus: {
          type: data.data.state,
          message: data.data.message,
        },
      });
    } catch (e) {
      this.setState({
        requestResultPullStatus: {
          type: "error",
          message: get(e, "response.data.message", this.props.i18n.t("Error")),
        },
      });
    }

    this.setState({ isLoading: false });
  };

  handleSubmit = async () => {
    this.setState({ isLoading: true });
    try {
      const data = await RedcapPushRequest(this.props.subjectID);

      this.setState({
        isSent: true,
        requestResult: {
          type: data.data.state,
          message: data.data.message,
        },
      });
    } catch (e) {
      this.setState({
        requestResult: {
          type: "error",
          message: get(e, "response.data.message", this.props.i18n.t("Error")),
        },
      });
    }

    this.setState({ isLoading: false });
  };

  handleSubmitCheckStatus = async () => {
    this.setState({ isLoadingStatus: true });
    try {
      const data = await RedcapCheckStatus(this.props.subjectID);

      this.setState({
        isSentStatus: true,
        requestResultStatus: {
          type: data.data.state,
          message: data.data.message,
        },
      });
    } catch (e) {
      this.setState({
        requestResultStatus: {
          type: "error",
          message: get(e, "response.data.message", this.props.i18n.t("Error")),
        },
      });
    }

    this.setState({ isLoadingStatus: false });
  };

  render() {
    const {} = this.props;

    const {
      isLoading,
      isSent,
      requestResult,
      isLoadingStatus,
      isSentStatus,
      requestResultStatus,
      isSentPullStatus,
      requestResultPullStatus,
    } = this.state;

    return (
      <div className={classes.patientProfileForm}>
        <div>
          <Button
            disabled={isSentPullStatus}
            type="primary"
            size="large"
            htmlType="button"
            onClick={this.handlePullSubmit}
            className={classes.submitButton}
          >
            {this.props.i18n.t('NamespacePatientIRedcapProcessing:Redcap Pull Subject')}
            {isLoading && <Icon type="loading" />}
          </Button>
          <br/><br/>
          {requestResultPullStatus && requestResultPullStatus.type &&
          <Alert message={requestResultPullStatus.message} type={statuses[requestResultPullStatus.type]} style={{ width: '300px'}}/>
          }
        </div>

        <br/>
        <div>
          <Button
            disabled={isSent}
            type="primary"
            size="large"
            htmlType="button"
            onClick={this.handleSubmit}
            className={classes.submitButton}
          >
            {this.props.i18n.t('NamespacePatientIRedcapProcessing:Redcap Push Subject')}
            {isLoading && <Icon type="loading" />}
          </Button>
          <br/><br/>
          {requestResult && requestResult.type &&
          <Alert message={requestResult.message} type={statuses[requestResult.type]} style={{ width: '300px'}}/>
          }
        </div>

        <br/>


        <div>
          <Button
            disabled={isSentStatus}
            type="primary"
            size="large"
            htmlType="button"
            onClick={this.handleSubmitCheckStatus}
            className={classes.submitButton}
          >
            {this.props.i18n.t('NamespacePatientIRedcapProcessing:Redcap Check Subject Status')}
            {isLoadingStatus && <Icon type="loading" />}
          </Button>
          <br/><br/>
          {requestResultStatus && requestResultStatus.type &&
          <Alert message={requestResultStatus.message} type={statuses[requestResultStatus.type]} style={{ width: '300px'}}/>
          }
        </div>
      </div>
    );
  }
}

export default withNamespaces()(PatientRedcapProcessing);



// WEBPACK FOOTER //
// ./src/components/PatientProfileForm/PatientRedcapProcessing.js